import {Network} from "../../../network/Network";
import {ProductType} from "../../../models/product/ProductType";
import {INetworkComponent} from "../../../network/types/INetworkComponent";
import {ICommunityAgentReportModel} from "../../../models/community/agent/ICommunityAgentReportModel";
import {WebSocketCommunityEventName} from "../../../network/socket/names/WebSocketCommunityEventName";
import {arrayRemove} from "../../../sedestral/framework/utilities/ArrayRemove";

export class CommunityAgentService {

    public static reportUpdateEvents: ((report: ICommunityAgentReportModel) => void)[] = [];

    public static dispose(): void {
        this.reportUpdateEvents = [];
    }

    public static init(): void {
        Network.on(ProductType.COMMUNITY, WebSocketCommunityEventName.COMMUNITY_AGENT_REPORT_UPDATE,
            (report: ICommunityAgentReportModel) => {
                this.reportUpdateEvents.forEach(value => value(report));
            });
    }

    static onReportUpdateEvent(component: INetworkComponent, type: number, func: (report: ICommunityAgentReportModel) => void) {
        let filteredFunc = (report: ICommunityAgentReportModel) => {
            if (report.type === type) {
                func(report);
            }
        };
        this.reportUpdateEvents.push(filteredFunc);
        component.onRemove(() => arrayRemove(this.reportUpdateEvents, filteredFunc));
    }
}
